import http from "@/services/http";

export const movements = () => {
  async function list({ date_start, date_end, page } = {}) {
    const { data } = await http.get('/movements/list', {
      params: { date_start, date_end, page }
    });
    return data;
  }

  return { list };
}
